

const Priviliges = [
    {
        Amiral_role                                : "Amiral_role",
	
        Admin_Role                                 : "Admin_Role",
        
        Customer_Role                              : "Customer_Role",
        
        Catalog_Access                             : "Catalog_Access",
        
        OrderList_Access                           : "OrderList_Access",
        
        BackOrder_Access                           : "BackOrder_Access",
        
        InvoicesList_Access                        : "InvoicesList_Access",
        
        BackOrder_Cancel                           : "BackOrder_Cancel",
        
        Sales_Statistics_Access                    : "Sales_Statistics_Access",
        
        Customer_Histories_Access                  : "Customer_Histories_Access",
        
        Synchronization_Reports_Access             : "Synchronization_Reports_Access",
        
        Customer_User_Management                   : "Customer_User_Management",
        
        Supplier_User_Management                   : "Supplier_User_Management",
        
        Advertising_Banners_Management             : "Advertising_Banners_Management",
        
        Announcements_Management                   : "Announcements_Management",
        
        Sales_Representatives_Customers_Management : "Sales_Representatives_Customers_Management",

        Manual_Order_Sync_Role                      : "Manual_Order_Sync_Role",
    },


];

export { Priviliges };